module.exports = __webpack_public_path__ + "media/newstyle/images/new-icon-facebook-d7fbabb1696d4eba9c28ac1522ab7700.svg";